
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ProjectEdit from '@/components/Project/ProjectEdit.vue';

@Component({
  components: {
    ProjectEdit,
  },
})
export default class ProjectEditButton extends Vue {
  @Prop(String) public id!: string;
  public showDialog = false;

  @Emit()
  public projectUpdated() {
    this.showDialog = false;
  }
}
